// Returns a random number
export default function () {
  return Math.floor(Math.random() * 1000 + 1);
}
